import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const usePaymentDetail = (id: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [payment, setPayment] = useState<PaymentItemDto>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const { isLoading } = useQuery(
    [endpoints.payment.info, {id: id}],
    () =>
      fetcher.payment.postPaymentInfo({id: id}),
    {
      onSuccess: (res: PaymentInfoResDto) => {
        switch (res.code) {
          case 200:
            setPayment(res.result?.info);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  
  const { mutate: paymentConfirm, isSuccess: confirmSuccess } = useMutation(
    [endpoints.payment.info_confirm],
    fetcher.payment.postPaymentConfirm,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: paymentUpdate, isSuccess: updateSuccess } = useMutation(
    [endpoints.payment.info_update],
    fetcher.payment.postPaymentUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  return { payment, paymentUpdate, paymentConfirm, updateSuccess, confirmSuccess};
};

export default usePaymentDetail;
